export default "__VITE_ASSET__BuQ1ruhw__"